<div class="acceptance-buttons">
    <app-button [ngClass]="yesButton" classes="small" [text]="textPositive"
        [disabled]="!isEnabled" (onClick)="onSelection($event, true)" >
    </app-button>
    <app-button [ngClass]="noButton" classes="small" [text]="textNegative"
        [disabled]="!isEnabled" (onClick)="onSelection($event, false)">
    </app-button>
</div>